//https://developers.google.com/maps/documentation/javascript/reference/map
//https://developers.google.com/maps/documentation/javascript/examples/place-details

const getName = (data, typeKey, typeName = 'long_name') => {
  const component = data.address_components.find(component =>
    component.types.includes(typeKey),
  )
  return Boolean(component) ? component[typeName] : undefined
}

const formatGPlacesAddress = data => {
  return {
    country: getName(data, 'country', 'short_name'),
    postalCode: getName(data, 'postal_code'),
    city: getName(data, 'locality'),
    route: getName(data, 'route'),
    streetNumber: getName(data, 'street_number'),
  }
}
const getAddressDetail = async (placeId, saveAddressCallback) => {
  const map = new window.google.maps.Map(document.getElementById('google-map'))
  const request = {
    placeId,
    fields: [
      // 'name',
      'address_component',
      //'formatted_address',
      'place_id',
    ],
  }

  const service = new window.google.maps.places.PlacesService(map)

  await service.getDetails(request, (place, status) => {
    if (status === 'OK') {
      const formattedData = formatGPlacesAddress(place)
      saveAddressCallback(formattedData)
    }
  })
}

export default getAddressDetail
